import { Component, ElementRef, Inject, NgModule, ViewChild, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { AnnouncementService } from 'src/app/shared/services/announcementservices/announcement.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
declare let window: any; // Optional if Bootstrap is global
declare let $: any;      // jQuery

@Component({
  selector: 'app-add-announcement',
  templateUrl: './add-announcement.component.html',
  styleUrl: './add-announcement.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, CKEditorModule]
})
export class AddAnnouncementComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('hiddenDate') hiddenDate!: ElementRef<HTMLInputElement>;
  public showSpinner = false;
  public Editor = ClassicEditor;
  title: any;
  start_time: any;
  start_date: any;
  // expiry_date: any;
  description = '';
  announcementIdGetFromRoute: number | null = null;
  getItAnnouncement: any;
  id: any;
  backendFiles: string[] = [];
  removedFiles: string[] = [];
  expiry_date: string = new Date().toISOString().split('T')[0]; // default today
  today: Date = new Date();
  constructor(
    public _announcementService: AnnouncementService,
    public _router: Router,
    private _avtivatedRoute: ActivatedRoute,
  ) { }
  ngAfterViewInit() {
    ($('[data-toggle="tooltip"]') as any).tooltip();
  }
  // isScheduled: boolean = false;
  // isPublished: boolean = false;
  status: 'scheduled' | 'published' = 'published';

  setStatus(status: 'scheduled' | 'published') {
    this.status = status;
  }

  selectedFiles: File[] = [];
  filePreviewUrls: { url: string, type: 'image' | 'video' }[] = [];
  filehere: File | null = null;
  fileType: 'image' | 'video' | null = null;

  ngOnInit(): void {
    this.getCategories();
    // Get ID from route params
    this.announcementIdGetFromRoute = Number(this._avtivatedRoute.snapshot.paramMap.get('id'));
    if (this.announcementIdGetFromRoute) {
      this.getAnnouncementForEdit();
    }
  }

  // start video or image drop or add
  ngOnDestroy() {
    this.filePreviewUrls
      .filter(f => f.type === 'video')
      .forEach(f => URL.revokeObjectURL(f.url));
  }
  triggerFileInput() {
    document.getElementById('fileInput')?.click();
  }


  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files) {
      this.handleFiles(files);
    }
  }

  removeFile(index: number) {
    const file = this.filePreviewUrls[index];

    // If it's an existing backend file → mark as removed
    if (this.backendFiles.includes(file.url)) {
      this.removedFiles.push(file.url);
      this.backendFiles = this.backendFiles.filter(f => f !== file.url);
    } else {
      // If it's a newly uploaded file → remove from selectedFiles
      this.selectedFiles = this.selectedFiles.filter(f => file.url.indexOf(f.name) === -1);
    }

    // Always remove from preview
    this.filePreviewUrls.splice(index, 1);
  }
  onDrop(event: DragEvent): void {
    event.preventDefault();
    document.querySelector('.drop-zone')?.classList.remove('drag-over');

    const files = event.dataTransfer?.files;
    if (files) {
      this.handleFiles(files);
    }
  }

  handleFiles(files: FileList | File[]) {
    Array.from(files).forEach(file => {
      this.selectedFiles.push(file);

      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => {
          this.filePreviewUrls.push({
            url: reader.result as string,
            type: 'image'
          });
        };
        reader.readAsDataURL(file);
      } else if (file.type.startsWith('video/')) {
        const videoUrl = URL.createObjectURL(file);
        this.filePreviewUrls.push({
          url: videoUrl,
          type: 'video'
        });
      }
    });
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    const dropZone = document.querySelector('.drop-zone');
    dropZone?.classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    const dropZone = document.querySelector('.drop-zone');
    dropZone?.classList.remove('drag-over');
  }

  categories: any;

  selectedCategory = '';
  dropdownOpen = false;
  newCategory = '';


  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.dropdownOpen = false;
  }

  openAddCategoryModal() {
    this.dropdownOpen = false;
    $('#addCategoryModal').modal('show');
  }


  onCategoryChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    if (value === 'add') {
      // Reset selection
      this.selectedCategory = '';

      // Open Bootstrap modal using jQuery
      $('#addCategoryModal').modal('show');
    }
  }
  closeModal() {
    $('#addCategoryModal').modal('hide');
    this.selectedCategory = ''; // Reset select
    this.newCategory = ''; // Optional: clear the input

  }
  addCategory() {
    // this.showSpinner = true;
    const data = {
      category_name: this.newCategory,
    };
    this._announcementService.storeCategory(data).then((value) => {
      // this.showSpinner = false;
      if (value?.data) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Category Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });

      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message || 'Something went wrong',
          showConfirmButton: false,
          timer: 1500,
        });
      }

    })
    this.getCategories();
    $('#addCategoryModal').modal('hide');
  }
  getCategories() {
    this._announcementService.getAllCategory().then((value) => {
      this.categories = value?.data;
    })
  }

  publishAnnouncement() {
    this.showSpinner = true;

    if (!this.title || !this.selectedCategory || !this.expiry_date || !this.status) {
      Swal.fire('Error', 'Please fill in all required fields', 'error');
      this.showSpinner = false;
      return;
    }
    if (!this.id) {
      const expiry = new Date(this.expiry_date);
      const today = new Date(this.today);
      expiry.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (expiry < today) {
        Swal.fire('Error', 'Expired date must be greater or equal to today', 'error');
        this.showSpinner = false;
        return;
      }
    }


    const formData = new FormData();
    if (this.id) formData.append('id', this.id);

    formData.append('title', this.title);
    formData.append('category', this.selectedCategory);
    formData.append('is_publish_now', this.status === 'published' ? '1' : '0');
    formData.append('is_scheduled', this.status === 'scheduled' ? '1' : '0');
    formData.append('expiry_date', this.expiry_date || '');
    formData.append('description', this.description || '');

    if (this.status === 'published') {
      const now = new Date();
      formData.append('start_date', now.toISOString().slice(0, 10));
      formData.append('start_time', now.toTimeString().slice(0, 5));
    }

    if (this.status === 'scheduled') {
      formData.append('start_date', this.start_date || '');
      formData.append('start_time', this.start_time || '');
    }

    // ✅ Append only NEW files
    this.selectedFiles.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });

    // ✅ Append removed files so backend deletes them
    this.removedFiles.forEach((file, index) => {
      formData.append(`removed_files[${index}]`, file);
    });
    const apiCall = this.id
      ? this._announcementService.editAnnouncement(formData)
      : this._announcementService.addsAnnouncement(formData);

    apiCall.then((value) => {
      this.showSpinner = false;
      if (value?.data) {
        Swal.fire({
          iconHtml: '<img src="../../assets/images/success-modal.svg" alt="image">',
          title: this.id ? 'Announcement Updated Successfully' : 'Announcement Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        }).then(() => this._router.navigate(['/announcements']));
      } else {
        Swal.fire({
          iconHtml: '<img src="../../assets/images/error-modal.svg" alt="image">',
          title: value?.message || 'Something went wrong',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }



  gotoAnnouncementManagement() {
    this._router.navigate(['/announcements']);
  }

  getAnnouncementForEdit() {
    this.showSpinner = true;
    this._announcementService.getAnnouncementDataForEdit(this.announcementIdGetFromRoute).then((value) => {
      this.getItAnnouncement = value?.data || [];
      if (this.getItAnnouncement) {
        this.patchForm(this.getItAnnouncement);
      }
      this.showSpinner = false;

    });
  }
  patchForm(data: any) {
    this.id = data.id || '';
    this.title = data.title || '';
    this.selectedCategory = data.category || null;

    if (data.is_scheduled) {
      this.status = 'scheduled';
      this.start_date = data.start_date;
      this.start_time = data.start_time;
    } else if (data.is_publish_now) {
      this.status = 'published';
    }

    this.expiry_date = data.expiry_date || null;
    this.description = data.description || '';

    // Save backend files
    this.backendFiles = data.files || [];

    // Show in preview (backend only, not in selectedFiles!)
    this.filePreviewUrls = this.backendFiles.map((fileUrl: string) => {
      const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(fileUrl);
      const isVideo = /\.(mp4|mov|avi|mkv|webm)$/i.test(fileUrl);

      return { type: isImage ? 'image' : isVideo ? 'video' : 'image', url: fileUrl };
    });
  }


  openDatePicker() {
    this.hiddenDate.nativeElement.showPicker(); // ✅ works in modern Chrome/Edge
    // fallback for Safari/Firefox:
    this.hiddenDate.nativeElement.click();
  }

  onDateChange(event: any) {
    this.expiry_date = event.target.value; // always YYYY-MM-DD
  }
}
